
import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { take } from 'rxjs/operators';
import { User } from 'src/app/models/user.model';
import { AccountService } from 'src/app/services/account.service';

@Directive({
  selector: '[appHasRole]'
})
export class HasRoleDirective implements OnInit {
  @Input() set appHasRole(roles: string | string[]) {
    this.viewContainer.clear();

    if (!this.user) return;

    const allowedRoles = Array.isArray(roles) ? roles : [roles];

    if (allowedRoles.includes(this.user.role)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

  user: User | null = null;

  constructor(
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private accountService: AccountService
  ) {
    this.accountService.currentUser$.pipe(take(1)).subscribe(user => {
      this.user = user;
    });
  }

  ngOnInit(): void {}
}
